import React, {useEffect, useState } from 'react';
import SoapResponse from '../SoapResponse';
import { properties } from '../../properties';
import ErrorPage from '../../ErrorPage';
import LoaderComp from '../LoaderComp';
import transidgenerator from '../../transidgenerator';
import $ from "jquery";


function SoapProbe({ apiUrl }) {
    const [soapProbe, setSoapProbe] = useState({
        operation: properties.OPERATIONS.probe,
        vendorid: properties.VENDOR_ID,
        transactionid: transidgenerator(),
        userid: properties.USER_ID,
        customerPresent: properties.CUSTOMER_PRESENT,
        method: properties.SOAP_METHOD,
        region: properties.SEL_REGION,
        password: properties.PASSWORD,
        mode: properties.MODE,
        type: properties.TYPE,
        security: ""
    });
 
    var canSubmit = true;
 
    function isNotNullCheck(e, field){
        if(e === "" || !e){
            document.getElementsByName(field)[0].classList.add("emptied");
            document.getElementsByName(field)[1].classList.add("emptied");
            canSubmit = false;
        }
        else{
            document.getElementsByName(field)[0].classList.remove("emptied");
            document.getElementsByName(field)[1].classList.remove("emptied");
        }
    }

    const [response, setResponse] = useState();

    function changeTransactionId(e) {
        isNotNullCheck(e.target.value,"WPG_transID");
        setSoapProbe({ ...soapProbe, transactionid: e.target.value });
    }

    function changeVendorId(e) {
        isNotNullCheck(e.target.value,"WPG_vendorID");
        setSoapProbe({ ...soapProbe, vendorid: e.target.value });
    }

    function changePwd(e) {
        isNotNullCheck(e.target.value,"vendorPwd");
        setSoapProbe({ ...soapProbe, password: e.target.value });
    }

    function changeMethod(e) {
        isNotNullCheck(e.target.value,"WPG_method");
        setSoapProbe({ ...soapProbe, method: e.target.value });
    }

    function changeRegion(e) {
        isNotNullCheck(e.target.value,"WPG_region");
        setSoapProbe({ ...soapProbe, region: e.target.value });
    }

    function changeUserId(e) {
        setSoapProbe({ ...soapProbe, userid: e.target.value });
    }

    function changeCustomerPresent(e) {
        isNotNullCheck(e.target.value,"WPG_customerPresent");
        setSoapProbe({ ...soapProbe, customerPresent: e.target.value });
    }

    var region =[];
 
    for(var property in properties.REGIONS){
        region.push(<option value={property} key={property}>{properties.REGIONS[property]}</option>);
    }

    async function submitTokenSettleForm(e) {
        e.preventDefault();
        isNotNullCheck(soapProbe.transactionid,"WPG_transID");
        isNotNullCheck(soapProbe.vendorid,"WPG_vendorID");
        isNotNullCheck(soapProbe.password,"vendorPwd");
        isNotNullCheck(soapProbe.method,"WPG_method");
        isNotNullCheck(soapProbe.region,"WPG_region");
        isNotNullCheck(soapProbe.customerPresent,"WPG_customerPresent");
        soapProbe.timestamp = Math.floor(Date.now() / 1000);
        var md5 = require('md5');
        const requestbody =
        {
            vendorID: soapProbe.vendorid,
            transID: soapProbe.transactionid,
            userID: soapProbe.userid,
            PEDIP: "173.46.75.123",
            method: soapProbe.method,
            customerPresent: soapProbe.customerPresent,
            timestamp: soapProbe.timestamp,
            region: soapProbe.region,
            mode: soapProbe.mode,
            type: soapProbe.type,
            security: md5(soapProbe.vendorid + soapProbe.transactionid + soapProbe.userid +
                soapProbe.method + soapProbe.customerPresent +
                 soapProbe.timestamp + soapProbe.region + soapProbe.password),
        };
        var xmlBody = [];
        xmlBody.push(properties.SOAP_REQUEST_PREFIX + "<ns1:probe>");
        for (var property in requestbody) {
            xmlBody.push("<" + property + ">" + requestbody[property] + "</" + property + ">");
        }
        xmlBody.push("</ns1:probe>" + properties.SOAP_REQUEST_SUFFIX);
        xmlBody = xmlBody.join("\n");
        var request = {
            method: 'POST',
            headers: new Headers({
                'Accept-Type': 'text/xml',
                'Content-Type': 'text/xml'
            }),
            body: xmlBody
        };
        if(canSubmit){
            document.getElementsByClassName("loader")[0].classList.add("loading");
            if(soapProbe.region === "NoR"){
                setSoapProbe({...soapProbe, region:""});
            }
            var statusCode;
            fetch(apiUrl, request)
            .then(resp => {
                if(Object.keys(properties.RESPONSE_STATUS_MESSAGE).indexOf(String(resp.status)) === -1){
                    return resp.text();
                }
                else{
                    statusCode = resp.status;
                    throw resp;
                }
            })
            .then(responsedata => setResponse(<SoapResponse title="Probe Response" operation="WPG_probe" message={responsedata} />))
            .catch((error)=>{
                console.log(error);
                setResponse(<ErrorPage code={statusCode} />);
            });
        }
    }
            
    useEffect(() => {
        $(".page-body").scrollTop(0);
    },[]);

    var soapProbeTemplate = (
        <div className="operation-form">
            <h2>Probe</h2>
            <form className="form-horizontal" method='post' onSubmit={submitTokenSettleForm}>
                <div className="form-group">
                    <div className="control-label">
                        Client Application ID<span className="mandatory-indicator">*</span>
                    </div>
                    <div className="col-sm-5">
                        <input type="text" className="form-control" name="WPG_vendorID" value={soapProbe.vendorid} onChange={changeVendorId} />
                        <div className="error-msg" name="WPG_vendorID">Client Application ID is mandatory</div>
                    </div>
                </div>
                <div className="form-group">
                    <div className="control-label">
                        Transaction ID<span className="mandatory-indicator">*</span>
                    </div>
                    <div className="col-sm-5">
                        <input type="text" className="form-control" name="WPG_transID" value={soapProbe.transactionid} onChange={changeTransactionId} />
                        <div className="error-msg" name="WPG_transID">Transaction ID is mandatory</div>
                    </div>
                </div>
                <div className="form-group">
                    <div className="control-label">
                        User ID
                    </div>
                    <div className="col-sm-5">
                        <input type="text" className="form-control" name="WPG_userid" value={soapProbe.userid} onChange={changeUserId} />
                    </div>
                </div>
                <div className="form-group">
                    <div className="control-label">
                        Customer Present<span className="mandatory-indicator">*</span>
                    </div>
                    <div className="col-sm-5">
                        <select className="form-control" name="WPG_customerPresent" value={soapProbe.customerPresent} onChange={changeCustomerPresent}>
                            <option value="Y">Yes</option>
                            <option value="N">No</option>
                        </select>
                        <div className="error-msg" name="WPG_customerPresent">Customer Present is mandatory</div>
                    </div>
                </div>
                <div className="form-group">
                    <div className="control-label">
                        Method<span className="mandatory-indicator">*</span>
                    </div>
                    <div className="col-sm-5">
                        <input type="text" className="form-control" name="WPG_method" value={soapProbe.method} onChange={changeMethod} />
                        <div className="error-msg" name="WPG_method">Method is mandatory</div>
                    </div>
                </div>
                <div className="form-group">
                    <div className="control-label">
                        Region<span className="mandatory-indicator">*</span>
                    </div>
                    <div className="col-sm-5">
                        <select className="form-control" name="WPG_region" value={soapProbe.region} onChange={changeRegion}>
                            {region}
                        </select>
                        <div className="error-msg" name="WPG_region">Region is mandatory</div>
                    </div>
                </div>
                <div className="form-group">
                    <div className="control-label">
                        Client Application Password<span className="mandatory-indicator">*</span>
                    </div>
                    <div className="col-sm-5">
                        <input type="password" className="form-control" name="vendorPwd" value={soapProbe.password} onChange={changePwd} />
                        <div className="error-msg" name="vendorPwd">Client Application Password is mandatory</div>
                    </div>
                </div>
                <div className="form-group">
                    <div className="col-sm-5">
                        <button type="submit" id="tokensettleButton" className="btn btn-primary">Perform</button>
                    </div>
                </div>
            </form>
            <div className="loader-div">
                <span className="loader"><LoaderComp/></span>
            </div>
        </div>

    );

    return response ? response : soapProbeTemplate;
}

export default SoapProbe;